import Analytics from './analytics'
import { GooglePlaces } from './maps.js'
import ConfirmBrowserRefresh from './confirm-browser-refresh'
import { PhoneNumberMask } from './input-masks.js'
import { PinInput } from './pin-input.js'
import { RateLimiter } from './rate-limiter.js'
import ScrollToTopOnClick from './scroll-top'

export const Hooks = {
  ...Analytics,
  ConfirmBrowserRefresh,
  GooglePlaces,
  PhoneNumberMask,
  PinInput,
  RateLimiter,
  ScrollToTopOnClick,
}
